class RejectPurchaseRequestModalController {
  constructor($uibModalInstance, modalContext) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.modalContext = modalContext || {};

    this.isReimbursement = !!this.modalContext.isReimbursement;
    this.reportName = this.modalContext.reportName || 'this request';
    this.title = this.modalContext.title
      || (this.isReimbursement ? 'Reject Reimbursement' : 'Reject Purchase Request');
    this.confirmLabel = this.modalContext.confirmLabel
      || (this.isReimbursement ? 'Reject Reimbursement' : 'Reject Request');
    this.placeholder = this.modalContext.placeholder
      || (this.isReimbursement
        ? 'Describe what needs to be corrected (e.g. receipt is missing, actual amount does not match documentation).'
        : 'Describe why this purchase request is being rejected and what the employee should change.');

    this.reason = '';
    this.errorMessage = '';
  }

  canSubmit() {
    return !!(this.reason && this.reason.trim());
  }

  confirm() {
    if (!this.canSubmit()) {
      this.errorMessage = 'Enter a rejection reason so the employee knows what to fix.';
      return;
    }

    this.$uibModalInstance.close(this.reason.trim());
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default RejectPurchaseRequestModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/general-business-review-details/modals/reject-purchase-request/reject-purchase-request.controller.js